if (!customElements.get('nx-buybox')) {
  customElements.define('nx-buybox', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-nxbb-form]');
      this.cards = [...this.querySelectorAll('[data-nxbb-card]')];
      this.idInput = this.querySelector('[data-nxbb-id]');
      this.qtyInput = this.querySelector('[data-nxbb-qty]');
      this.cta = this.querySelector('[data-nxbb-cta]');
      this.ctaText = this.querySelector('[data-nxbb-cta-text]');
      this.error = this.querySelector('[data-nxbb-error]');
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.nights = parseInt(this.dataset.nights, 10) || 30;
      this.busy = false;

      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.select(card));
        card.querySelector('input').addEventListener('change', () => this.select(card));
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.addToCart();
      });

      this.initShipsBy();
      this.initSticky();
      const start = this.cards.find((c) => c.classList.contains('is-selected') && c.dataset.available === 'true')
        || this.cards.find((c) => c.dataset.available === 'true');
      this.select(start);
    }

    money(cents) {
      const n = Number(cents) / 100;
      const fmt = (d, sep = ',', dec = '.') => {
        const [i, f] = n.toFixed(d).split('.');
        return i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (f ? dec + f : '');
      };
      return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
        if (k === 'amount_no_decimals') return fmt(0);
        if (k === 'amount_with_comma_separator') return fmt(2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
        return fmt(2);
      });
    }

    select(card) {
      if (!card || card.dataset.available !== 'true') return;
      this.selected = card;
      this.cards.forEach((c) => {
        const on = c === card;
        c.classList.toggle('is-selected', on);
        c.querySelector('input').checked = on;
        this.renderCard(c);
      });

      this.idInput.value = card.dataset.variantId;
      this.qtyInput.value = card.dataset.qty || 1;

      const price = Number(card.dataset.price);
      this.ctaText.textContent = `${this.cta.dataset.label} — ${this.money(price)}`;

      const gifts = this.querySelector('[data-nxbb-gifts]');
      if (gifts) gifts.hidden = card.dataset.gifts !== 'true';

      const stickyPrice = this.querySelector('[data-nxbb-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = this.money(price);
      const stickyTitle = this.querySelector('[data-nxbb-sticky-title]');
      if (stickyTitle) stickyTitle.textContent = card.querySelector('.nxbb__title').textContent.trim();
    }

    renderCard(c) {
      const price = Number(c.dataset.price);
      const compare = Number(c.dataset.compare);
      const units = Number(c.dataset.units) || 1;
      const save = compare > price ? Math.round(((compare - price) / compare) * 100) : 0;

      c.querySelector('[data-nxbb-price]').textContent = this.money(price);
      const cmp = c.querySelector('[data-nxbb-compare]');
      cmp.hidden = save < 1;
      cmp.textContent = this.money(compare);
      const pill = c.querySelector('[data-nxbb-save]');
      pill.hidden = save < 1;
      pill.textContent = `Save ${save}%`;
      c.querySelector('[data-nxbb-pernight]').textContent = this.money(Math.round(price / (units * this.nights)));
    }

    setBusy(on) {
      this.busy = on;
      this.cta.disabled = on;
      this.cta.setAttribute('aria-busy', on);
      const sticky = this.querySelector('[data-nxbb-sticky-btn]');
      if (sticky) sticky.disabled = on;
      if (on) this.ctaText.textContent = 'Adding…';
      else if (this.selected) this.select(this.selected);
    }

    async addToCart() {
      if (this.busy || !this.selected) return;
      this.setBusy(true);
      this.error.hidden = true;

      const items = [{ id: Number(this.idInput.value), quantity: Number(this.qtyInput.value) || 1 }];
      if (this.selected.dataset.gifts === 'true') {
        this.querySelectorAll('[data-nxbb-gift-variant]').forEach((g) => {
          const id = Number(g.dataset.nxbbGiftVariant);
          if (id) items.push({ id, quantity: 1, properties: { _nx_gift: 'true' } });
        });
      }

      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const canRender = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
      const body = { items };
      if (canRender) {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }

      let data;
      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart. Please try again.');
      } catch (err) {
        this.error.textContent = err.message;
        this.error.hidden = false;
        this.setBusy(false);
        return;
      }

      // Added. Open the theme's cart drawer; if anything about the drawer fails, go to the cart page.
      try {
        if (!canRender || !data.sections) throw new Error('no drawer');
        const first = (data.items && data.items[0]) || {};
        cart.classList.remove('is-empty');
        cart.renderContents({ ...first, sections: data.sections });
        if (typeof cart.open === 'function' && !cart.classList.contains('active')) cart.open();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        this.setBusy(false);
      } catch (e) {
        window.location.href = `${root}cart`;
      }
    }

    initShipsBy() {
      const el = this.querySelector('[data-nxbb-ships]');
      const out = el && el.querySelector('[data-nxbb-ships-date]');
      if (!out) return;
      const tz = el.dataset.tz;
      const cutoff = parseInt(el.dataset.cutoff, 10);
      let lead = parseInt(el.dataset.lead, 10) || 0;
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
          .formatToParts(new Date()).map((p) => [p.type, p.value])
      );
      const d = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12));
      const isWeekend = () => d.getUTCDay() === 0 || d.getUTCDay() === 6;
      if (+parts.hour >= cutoff) lead += 1;
      while (lead > 0 || isWeekend()) {
        d.setUTCDate(d.getUTCDate() + 1);
        if (!isWeekend()) lead -= 1;
      }
      out.textContent = d.toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' });
    }

    initSticky() {
      const bar = this.querySelector('[data-nxbb-sticky]');
      if (!bar) return;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }).observe(this.cta);
      }
      // The sticky button adds the currently selected option straight to the cart.
      bar.querySelector('[data-nxbb-sticky-btn]').addEventListener('click', () => this.addToCart());
    }
  });
}
